import React from "react";
import "./Footer.css";

export default function Footer() {
    const openMembersView = () => {
        try {
            localStorage.setItem("lastView", "profile");
            localStorage.setItem("admin_last_view", "profile");
            localStorage.setItem("footer_member_target", "profile");
            const role = localStorage.getItem("role");
            if (role === "admin" || role === "comelec") {
                localStorage.setItem("admin_preview_mode", "yes");
            }
        } catch {
            // Ignore storage access issues and keep the normal /member link behavior.
        }
    };

    return (
        <footer className="site-footer">
            <div className="footer-content">
                <p>
                    &copy; {new Date().getFullYear()} Southern Alberta Regional Council Canada,
                    Triskelions Grand Fraternity and Sorority. All rights reserved.
                </p>

                <p className="footer-links">
                    <a href="/#about">About Us</a> |{" "}
                    <a href="/#gallery">Gallery</a> |{" "}
                    <a href="/member?view=members" onClick={openMembersView}>Members</a> |{" "}
                    {/* <a href="/#business">Businesses</a> |{" "} */}
                    <a href="/privacy">Privacy Policy</a> |{" "}
                    <a href="/terms">Terms of Use</a>
                </p>

                <p className="footer-watermark">
                    Developed by <span>MDPJ</span>
                </p>
            </div>
        </footer>
    );
}
